let _isMobile;
export function isMobile() {
  if (typeof _isMobile === "undefined") {
    _isMobile = navigator.userAgent.match(
      /(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/
    );
  }
  return _isMobile;
}
